import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/style.enquiryform.css'; // Import custom CSS for additional styling

function Enquiry() {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    fullName: '',
    email: '',
    mobile: '',
    address: '',
    enquiry: ''
  });

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage('');
      }, 5000); // Hide the success message after 5 seconds

      return () => clearTimeout(timer); // Clear the timeout if the component is unmounted or if successMessage changes
    }
  }, [successMessage]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleOnFormComplete();
  };

  const handleOnFormComplete = async () => {
    try {
      const response = await fetch('https://api.krushiratnamilk.com/api/enquiries', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(form)
      });

      if (!response.ok) {
        throw new Error('Failed to submit enquiry');
      }

      await response.json();

      setSuccessMessage(t('Enquiry submitted successfully!'));
      setErrorMessage('');
      setForm({
        firstName: '',
        lastName: '',
        company: '',
        city: '',
        email: '',
        mobile: '',
  
        enquiry: ''
      });
    } catch (error) {
      console.error('Error submitting enquiry:', error);
      setErrorMessage(t('Error submitting enquiry. Please try again later.'));
      setSuccessMessage('');
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col md={8}>
          <Card className="shadow-lg p-4 enquiry-card">
            <Card.Body>
              <h1 className="text-center mb-4">{t('Enquiry Form')}</h1>
              <p className="text-center mb-4">
                {t('We are looking forward to understanding your needs and partnering with you. Please fill the following form. We will get in touch with you!')}
              </p>
              {successMessage && <Alert variant="success">{successMessage}</Alert>}
              {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="formFullName" className="mb-3">
                      <Form.Label>{t('Full Name')}</Form.Label>
                      <Form.Control
                        type="text"
                        name="fullName"
                        value={form.fullName}
                        onChange={handleChange}
                        placeholder={t('Enter your full name')}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="formMobile" className="mb-3">
                      <Form.Label>{t('Mobile')}</Form.Label>
                      <Form.Control
                        type="text"
                        name="mobile"
                        value={form.mobile}
                        onChange={handleChange}
                        placeholder={t('Enter your mobile number')}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="formEmail" className="mb-3">
                      <Form.Label>{t('E-mail')}</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder={t('Enter your E-mail')}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="formAddress" className="mb-3">
                      <Form.Label>{t('Address')}</Form.Label>
                      <Form.Control
                        type="text"
                        name="address"
                        value={form.address}
                        onChange={handleChange}
                        placeholder={t('Enter your Address')}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group controlId="formEnquiry" className="mb-3">
                  <Form.Label>{t('Enquiry')}</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="enquiry"
                    value={form.enquiry}
                    onChange={handleChange}
                    placeholder={t('Enter your enquiry')}
                    rows={4}
                    required
                  />
                </Form.Group>

                <Button variant="primary" type="submit" className="w-100">
                  {t('Submit')}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Enquiry;
